import {
  formatPercentageValue,
  formatNormalNumber,
  createKpiTileItem,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { newUser, newUserDelta } = data.getUserAdoptionScorecard;

    return createKpiTileItem(
      'New Users',
      formatNormalNumber(newUser),
      newUserDelta
        ? {
            isPositiveValue: newUserDelta >= 0,
            text: formatPercentageValue(Math.abs(newUserDelta)),
            sideLabel: '',
            showArrow: Number(newUserDelta) !== 0,
          }
        : null
    );
  },
};
